import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PricingService } from '../../../pricing/pricing.service';

@Component({
  selector: 'app-main',
  templateUrl: './main-block.component.html',
  styleUrls: ['./main-block.component.scss'],
})
export class MainBlockComponent implements OnInit  {
  constructor(protected readonly pricingService: PricingService) {
  }

  protected tariffs: any[] = [];

  ngOnInit(): void {
    this.pricingService.getTariffs()
      .subscribe((res) => {
        this.tariffs = res;
      });
  }

  protected readonly environment = environment;

}
